const cards = [
  {
    title: '暑期档观影指南',
    desc: '今年暑期档佳片云集，从国产科幻到好莱坞动作大片，我们为你整理了最全片单和观影顺序建议。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20lighting%2C%20red%20velvet%20seats%2C%20large%20silver%20screen%20displaying%20abstract%20light%20patterns%2C%20luxurious%20vintage%20cinema%20atmosphere%2C%20rich%20amber%20and%20crimson%20tones%2C%20elegant%20composition&width=600&height=400&seq=card-guide-2026&orientation=landscape',
  },
  {
    title: '高分悬疑剧盘点',
    desc: '10部豆瓣8.5+国产悬疑剧，从经典到新作，每一部都让你欲罢不能，烧脑程度层层递进。',
    tag: '剧集推荐',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20atmospheric%20scene%20with%20warm%20amber%20desk%20lamp%20lighting%20on%20old%20wooden%20desk%2C%20scattered%20case%20files%20and%20photographs%2C%20detective%20investigation%20board%20with%20red%20strings%20in%20background%2C%20noir%20cinematography%20style%2C%20rich%20shadows%20and%20warm%20highlights&width=600&height=400&seq=card-mystery-list-2026&orientation=landscape',
  },
  {
    title: '日漫七月新番速递',
    desc: '七月新番已全部上线，热血、治愈、悬疑各类题材一网打尽，双语字幕同步日本播出。',
    tag: '动漫资讯',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20with%20warm%20sunset%20color%20palette%2C%20vibrant%20whimsical%20sky%20with%20soft%20clouds%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20dreamy%20atmosphere%2C%20warm%20orange%20and%20pink%20gradient%2C%2C%20cinematic%20composition&width=600&height=400&seq=card-anime-news-2026&orientation=landscape',
  },
  {
    title: '经典港片修复合集',
    desc: '多部经典香港电影4K修复版上线，重温黄金年代的银幕记忆，画质焕然一新，情怀依旧。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cityscape%20at%20night%20with%20vibrant%20neon%20signs%20in%20warm%20red%20and%20gold%20tones%2C%20busy%20street%20scene%20with%20nostalgic%2090s%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20wet%20pavement%20reflections%2C%20dense%20urban%20texture&width=600&height=400&seq=card-hk-classic-2026&orientation=landscape',
  },
  {
    title: '纪录片爱好者必看',
    desc: '从自然生态到人文历史，精选20部高分纪录片带你领略真实世界的震撼与感动，全平台可看。',
    tag: '精选专题',
    img: 'https://readdy.ai/api/search-image?query=Breathtaking%20natural%20landscape%20with%20dramatic%20golden%20hour%20lighting%2C%20majestic%20mountain%20range%20reflected%20in%20crystal%20clear%20lake%2C%20warm%20amber%20and%20soft%20teal%20color%20palette%2C%20documentary%20cinematography%20style%2C%20serene%20and%20awe-inspiring%20composition&width=600&height=400&seq=card-docu-2026&orientation=landscape',
  },
  {
    title: '综艺爆笑名场面',
    desc: '本周综艺名场面合集已更新，从户外挑战到室内游戏，各种笑点密集输出，快乐源泉不断。',
    tag: '综艺精选',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20entertainment%20show%20stage%20with%20bright%20warm%20studio%20lighting%2C%20confetti%20and%20colorful%20decorations%2C%20lively%20festive%20atmosphere%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20dynamic%20energy%2C%20television%20production%20setup&width=600&height=400&seq=card-variety-fun-2026&orientation=landscape',
  },
  {
    title: '周末电影马拉松',
    desc: '周末宅家看什么？我们精选了7部不同类型的高分电影，从早看到晚，一天都不够用。',
    tag: '片单推荐',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20living%20room%20scene%20with%20warm%20ambient%20lighting%2C%20large%20television%20screen%20displaying%20soft%20cinematic%20glow%2C%20comfortable%20sofa%20with%20blankets%2C%20evening%20atmosphere%20with%20warm%20lamp%20light%2C%20relaxed%20movie%20night%20vibe%2C%20golden%20and%20amber%20tones&width=600&height=400&seq=card-weekend-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            影视资讯
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            最新影视动态、专题推荐和观影指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="overflow-hidden aspect-[3/2]">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="300"
                  height="200"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  {card.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}

          <div className="bg-background-50 border-2 border-dashed border-background-300 rounded-xl p-6 flex flex-col items-center justify-center text-center hover:border-primary-300 transition-colors cursor-pointer min-h-[200px] lg:min-h-0">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
            <h3 className="text-base font-semibold text-foreground-800 mb-1">
              更多影视资讯
            </h3>
            <p className="text-sm text-foreground-500">
              探索更多精彩内容
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}